import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  button: {
    minWidth: 'auto',
    padding: 2,
    borderRadius: '50%',
  },
  icon: {
    fontSize: '2rem',
    color: theme.custom.darkBlue,
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.5rem',
    },
  },
  ul: {
    display: 'flex',
    width: '100%',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  li: (props) => ({
    width: `calc(100% / ${(props as any).count})`,
    fontSize: 16,
    fontWeight: 600,
    color: '#777777',
    textAlign: 'center',
    textTransform: 'capitalize',
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  }),
}));
